const requestDefaultConfigs = {
  mode: "same-origin",
  credentials: "same-origin",
  headers: {
    "X-Requested-With": "XMLHttpRequest",
    "Content-Type": "application/json",
  },
};
function queryDomNodes(selectors = {}, context = document) {
  const domNodes = Object.entries(selectors).reduce((acc, [name, selector]) => {
    const findOne = typeof selector === "string";
    const queryMethod = findOne ? "querySelector" : "querySelectorAll";
    const sl = findOne ? selector : selector[0];

    if (context) {
      acc[name] = context[queryMethod](sl);
    }
    if (!findOne && acc[name]) {
      acc[name] = [...acc[name]];
    }
    return acc;
  }, {});
  return domNodes;
}
function addEventDelegate({ context = document.documentElement, event = "click", selector, handler, capture = false }) {
  const listener = function (e) {
    // loop parent nodes from the target to the delegation node
    for (let target = e.target; target && target !== this; target = target.parentNode) {
      if (target.matches(selector)) {
        handler.call(target, e, target);
        break;
      }
    }
  };
  context.addEventListener(event, listener, capture);
  return () => {
    context.removeEventListener(event, listener, capture);
  };
}
const sectionCache = new Map();
function fetchSection(sectionId, options = {}) {
  const { url: _url, fromCache = false, params = {} } = options;

  return new Promise((resolve, reject) => {
    const url = new URL(_url || window.location.href);
    url.searchParams.set("section_id", sectionId);
    Object.entries(params).forEach(([k, v]) => url.searchParams.set(k, v));

    if (fromCache) {
      const cached = sectionCache.get(url);
      if (cached) return resolve(cached);
    }

    fetch(url, JSON.parse(JSON.stringify(requestDefaultConfigs)))
      .then((res) => {
        if (res.ok) return res.text();
        reject(`Failed to load section: ${sectionId}`);
      })
      .then((html) => {
        const d = document.createElement('div');
        d.innerHTML = html;
        sectionCache.set(url, d);
        resolve(d);
        // const div = <div />
        // div.innerHTML = html
        // sectionCache.set(url, div)
        // resolve(div)
      })
      .catch(reject);
  });
}

class MCartAddons extends HTMLElement {
  constructor() {
    super();

    this.selectors = {
      zipCode: '[name="address[zip]"]',
      province: '[name="address[province]"]',
      country: '[name="address[country]"]',
      addressForm: '[data-address="root"]',
      shippingMessage: ".m-cart-addon__shipping-rate",
      cartDiscountCode: '[name="discount"]',
      cartDiscountCodeNoti: "[data-discount-noti]",
      cartDiscountMessage: "[data-discount-message]",
      cartNote: "#CartAddon-Note, [name='note']",
      saveAddonButton: ".m-cart-addon--save",
      closeAddonButton: ".m-cart-addon--close",
      calcShippingButton: ".m-cart-addon--calculate",
      triggerAddonButton: ".m-cart-addon--trigger-button",
      devliveryTime: '[name="attributes[Delivery time]"]',
    };

    this.cartWrapper = document.querySelector(".m-cart-drawer");
    this.isCartPage = this.dataset.template === "cart";
    console.log("Is cart page:", this.isCartPage);


    if (this.isCartPage) { 
      this.cartWrapper = document.querySelector(".m-cart__footer--wrapper");
    }

    this.initAddress = false;
    this.cartOverlay = this.cartWrapper?.querySelector(".m-cart__overlay");
    console.log("Cart overlay:", this.cartOverlay);

    this.domNodes = queryDomNodes(this.selectors, this);
    console.log("DOM nodes found:", this.domNodes);

    this.rootUrl = window.Shopify.routes.root;
    this.discountCodeKey = "minimog-discount-code";
    this.deliveryCodeKey = "minimog-delivery-code";

    this.init();
  }

  init() {
    console.log("Initializing MCartAddons");
    const { cartDiscountCode, cartDiscountCodeNoti, devliveryTime } = this.domNodes;

    addEventDelegate({
      selector: this.selectors.triggerAddonButton,
      context: this,
      handler: (e, addonButton) => {
        e.preventDefault();
        console.log("Addon trigger clicked:", addonButton);

        if (this.isCartPage) {
          const addonCurrentActive = document.querySelector(".m-cart-addon__body.open");
          if (addonCurrentActive) {
            console.log("Closing previously open addon");
            addonCurrentActive.classList.remove("open");
          }
        }

        const { open: addonTarget } = addonButton.dataset;
        console.log("Opening addon target:", addonTarget);

        const addonNode = this.cartWrapper.querySelector(`#m-addons-${addonTarget}`);
        console.log("Addon node found:", addonNode);

        this.removeActiveAllButton();
        addonButton.classList.add("active");
        addonNode?.classList.add("open");
        this.cartOverlay?.classList.add("open");

        this.openAddon = addonNode;

        if (addonTarget === "shipping") {
          console.log("Fetching shipping country options...");
          fetchSection("country-options", { url: window.location.origin + Shopify.routes.root })
            .then((html) => {
              console.log("Country options fetched:", html);
              const select = html.querySelector("#AddressCountry");
              const options = select?.querySelectorAll("option");
              const defaultSelect = addonNode.querySelector("#MadrressCountry select");
              options?.forEach((option) => defaultSelect?.appendChild(option));
              this.setupCountries();
              defaultSelect.value = defaultSelect?.dataset.default;
            })
            .catch((err) => console.error("Shipping fetch error:", err));
        }
      },
    });

    addEventDelegate({
      selector: this.selectors.closeAddonButton,
      context: this.cartWrapper,
      handler: (e, target) => {
        if (target.dataset.action === "coupon") {
          e.preventDefault();
          e.stopPropagation();
          this.removeCartDiscount(e, target);
          return;
        }
        if (target.dataset.action === "note") {
          e.preventDefault();
          e.stopPropagation();
          this.removeCartNote(e, target);
          return;
        }
        this.close(e);
      },
    });

    if (cartDiscountCode) {
      cartDiscountCode.addEventListener("keydown", (event) => {
        if (event.key !== "Enter") return;
        event.preventDefault();
        const saveButton = this.querySelector('.m-cart-addon--save[data-action="coupon"]');
        saveButton?.click();
      });
    }

    addEventDelegate({
      selector: this.selectors.calcShippingButton,
      context: this.cartWrapper,
      handler: (e) => {
        console.log("Calculating shipping");
        this.calcShipping(e);
      },
    });

    if (cartDiscountCode) {
      const code = localStorage.getItem(this.discountCodeKey);
      console.log("Loaded discount code from storage:", code);
      if (code) {
        cartDiscountCode.value = code;
        if (cartDiscountCodeNoti) {
          cartDiscountCodeNoti.style.display = "inline";
        }
      }
    }

    if (devliveryTime) {
      const code = localStorage.getItem(this.deliveryCodeKey);
      console.log("Loaded delivery code from storage:", code);
      if (code) devliveryTime.value = code;
    }

    this.saveAddonValue();

    const today = new Date().toISOString().slice(0, 16);
    const deliveryTimeElm = this.querySelector("#delivery-time");
    if (deliveryTimeElm) deliveryTimeElm.min = today;
  }

  removeActiveAllButton() {
    console.log("Removing active class from all addon buttons");
    const triggerButtons = this.querySelectorAll(this.selectors.triggerAddonButton);
    triggerButtons?.forEach((button) => button.classList.remove("active"));
  }

  setupCountries() {
    if (this.initAddress) return;
    console.log("Initializing Shopify country/province selector");
    if (Shopify && Shopify.CountryProvinceSelector) {
      new Shopify.CountryProvinceSelector("AddressCountry", "AddressProvince", {
        hideElement: "AddressProvinceContainer", 
      });
      this.initAddress = true;
    }
  }


  close(event) {
    event?.preventDefault();
    const addon = this.openAddon || this.querySelector(".m-cart-addon__body.open");
    if (addon) {
      addon.style.height = "0px";
      addon.classList.remove("open");
    }
    this.cartOverlay?.classList.remove("open");
    this.removeActiveAllButton();
    this.openAddon = null;
  }

  calcShipping(event) {
    event.preventDefault();
    console.log("calcShipping called");
    const actionsWrapper = event.target.closest(".m-cart-addon__action");
    actionsWrapper.classList.add("m-spinner-loading");

    const zipCode = this.domNodes.zipCode?.value.trim();
    const country = this.domNodes.country?.value;
    const province = this.domNodes.province?.value;
    console.log("Shipping info:", { zipCode, country, province });

    this.domNodes.shippingMessage.classList.remove("error");
    this.domNodes.shippingMessage.innerHTML = "";

    const showDeliveryDays = actionsWrapper.dataset.showDeliveryDays === "true";

    fetch(
      `${this.rootUrl}cart/shipping_rates.json?shipping_address%5Bzip%5D=${zipCode}&shipping_address%5Bcountry%5D=${country}&shipping_address%5Bprovince%5D=${province}`
    )
      .then((res) => res.json())
      .then((res) => {
        console.log("Shipping rates response:", res);
        actionsWrapper.classList.remove("m-spinner-loading");
        if (res?.shipping_rates?.length > 0) {
          res.shipping_rates.forEach((rate) => {
            console.log("Shipping rate:", rate);
          });
        } else {
          console.warn("No shipping rates found or error in response");
        }
      })
      .catch((err) => console.error("Shipping fetch error:", err));
  }

  saveAddonValue() {
    console.log("Setting up saveAddonValue events");
    addEventDelegate({
      event: "click",
      context: this.cartWrapper,
      selector: this.selectors.saveAddonButton,
      handler: (event, target) => {
        console.log("Save addon button clicked:", target.dataset.action);
        event.preventDefault();
        const { cartDiscountCode, cartDiscountCodeNoti, devliveryTime } = this.domNodes;

        if (target.dataset.action === "coupon" && cartDiscountCode) {
          event.stopPropagation();
          this.applyCartDiscount(event, target);
          return;
        }

        if (target.dataset.action === "note") {
          event.stopPropagation();
          this.saveCartNote(event, target);
          return;
        }

        if (target.dataset.action === "delivery") {
          const code = devliveryTime.value;
          const isValidDate = Date.parse(code);
          console.log("Saving delivery time:", code, "Valid:", isValidDate > Date.now());
          if (isValidDate > Date.now()) {
            localStorage.setItem(this.deliveryCodeKey, code);
            this.close(event);
          } else {
            localStorage.setItem(this.deliveryCodeKey, "");
            devliveryTime.value = "";
            console.warn("Invalid delivery date:", code);
          }
        }
      },
    });
  }
  getCartNoteElement() {
    return this.querySelector("#CartAddon-Note") || this.querySelector('[name="note"]') || this.domNodes.cartNote;
  }

  setNoteLoading(button, isLoading) {
    const actions = button?.closest(".m-cart-addon__action");
    actions?.classList.toggle("m-spinner-loading", isLoading);
    this.querySelectorAll('[data-action="note"]').forEach((el) => {
      el.disabled = isLoading;
    });
  }

  updateCartNote(noteValue) {
    const cartNoteElement = this.getCartNoteElement();
    const value = noteValue !== undefined ? noteValue : cartNoteElement?.value || "";

    if (cartNoteElement) {
      cartNoteElement.value = value;
    }

    const root = this.getCartRoot();
    return fetch(`${root}cart/update.js`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
      body: JSON.stringify({ note: value }),
    }).then((res) => {
      if (!res.ok) throw new Error("Cart note update failed");
      return res.json();
    });
  }

  async saveCartNote(event, button) {
    const cartNoteElement = this.getCartNoteElement();
    if (!cartNoteElement) {
      console.error("Cart note element not found!");
      return;
    }

    this.setNoteLoading(button, true);

    try {
      await this.updateCartNote(cartNoteElement.value);
      this.close(event);
    } catch (error) {
      console.error("Save cart note failed:", error);
    } finally {
      this.setNoteLoading(button, false);
    }
  }

  async removeCartNote(event, button) {
    const cartNoteElement = this.getCartNoteElement();
    this.setNoteLoading(button, true);

    try {
      if (cartNoteElement) cartNoteElement.value = "";
      await this.updateCartNote("");
      this.close(event);
    } catch (error) {
      console.error("Remove cart note failed:", error);
    } finally {
      this.setNoteLoading(button, false);
    }
  }

  getCartRoot() {
    return window.Shopify?.routes?.root || "/";
  }

  setCouponLoading(button, isLoading) {
    const actions = button?.closest(".m-cart-addon__action");
    actions?.classList.toggle("m-spinner-loading", isLoading);
    this.querySelectorAll('[data-action="coupon"]').forEach((el) => {
      el.disabled = isLoading;
    });
  }

  showDiscountMessage(message, isError = false) {
    const messageEl =
      this.domNodes.cartDiscountMessage || this.querySelector("[data-discount-message]");
    if (!messageEl) return;

    messageEl.hidden = !message;
    messageEl.textContent = message || "";
    messageEl.classList.toggle("is-error", Boolean(message) && isError);
    messageEl.classList.toggle("is-success", Boolean(message) && !isError);
  }

  isDiscountApplicable(cart, code) {
    if (!code) return true;

    const discountCodes = cart?.discount_codes;
    if (!Array.isArray(discountCodes) || !discountCodes.length) {
      return cart?.total_discount > 0;
    }

    return discountCodes.some(
      (discount) =>
        discount.code?.toLowerCase() === code.toLowerCase() && discount.applicable
    );
  }

  async updateCartDiscount(code) {
    const root = this.getCartRoot();
    const payload = {
      discount: code || "",
      sections: ["cart-drawer"],
      sections_url: window.location.pathname,
    };

    const response = await fetch(`${root}cart/update.js`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
      body: JSON.stringify(payload),
    });

    if (response.ok) {
      return response.json();
    }

    if (code) {
      await fetch(`${root}discount/${encodeURIComponent(code)}`);
    }

    const [cart, sectionHtml] = await Promise.all([
      fetch(`${root}cart.js`).then((res) => res.json()),
      fetch(`${root}cart?section_id=cart-drawer`).then((res) => res.text()),
    ]);

    cart.sections = { "cart-drawer": sectionHtml };
    return cart;
  }

  renderUpdatedCartDrawer(parsedState) {
    const sectionHtml = parsedState?.sections?.["cart-drawer"];
    const cartDrawerItems = document.querySelector("cart-drawer-items");

    if (!sectionHtml) {
      return cartDrawerItems?.onCartUpdate?.();
    }

    const html = new DOMParser().parseFromString(sectionHtml, "text/html");
    const selectors = ["cart-drawer-items", ".cart-drawer__footer", ".drawer__footer .cart__ctas"];

    selectors.forEach((selector) => {
      const targetElement = document.querySelector(selector);
      const sourceElement = html.querySelector(selector);
      if (targetElement && sourceElement) {
        targetElement.replaceWith(sourceElement);
      }
    });

    return Promise.resolve();
  }

  async applyCartDiscount(event, button) {
    const { cartDiscountCode, cartDiscountCodeNoti } = this.domNodes;
    const code = cartDiscountCode?.value.trim();

    if (!code) {
      this.showDiscountMessage("Please enter a discount code", true);
      return;
    }

    this.setCouponLoading(button, true);
    this.showDiscountMessage("");

    try {
      const cart = await this.updateCartDiscount(code);

      if (!this.isDiscountApplicable(cart, code)) {
        this.showDiscountMessage("This discount code is invalid or expired", true);
        return;
      }

      localStorage.setItem(this.discountCodeKey, code);
      if (cartDiscountCodeNoti) {
        cartDiscountCodeNoti.style.display = "inline";
      }

      await this.renderUpdatedCartDrawer(cart);
      this.close(event);
    } catch (error) {
      console.error("Apply discount failed:", error);
      this.showDiscountMessage("Unable to apply discount code. Please try again.", true);
    } finally {
      this.setCouponLoading(button, false);
    }
  }

  async removeCartDiscount(event, button) {
    const { cartDiscountCode, cartDiscountCodeNoti } = this.domNodes;

    this.setCouponLoading(button, true);
    this.showDiscountMessage("");

    try {
      localStorage.removeItem(this.discountCodeKey);
      if (cartDiscountCode) cartDiscountCode.value = "";
      if (cartDiscountCodeNoti) cartDiscountCodeNoti.style.display = "none";

      const cart = await this.updateCartDiscount("");
      await this.renderUpdatedCartDrawer(cart);
      this.close(event);
    } catch (error) {
      console.error("Remove discount failed:", error);
      this.showDiscountMessage("Unable to remove discount. Please try again.", true);
    } finally {
      this.setCouponLoading(button, false);
    }
  }
}

customElements.define("m-cart-addons", MCartAddons);

document.body.addEventListener("click", function (event) { 

  const overlay = document.querySelector(".m-cart__overlay");

  const closeAllAddons = () => {
    document
      .querySelectorAll(".m-cart-addon__body.open")
      .forEach(el => {
        el.style.height = "0px";
        el.classList.remove("open");
      });

    overlay?.classList.remove("open");
  };

  const openButton = event.target.closest("[data-open]");
  if (openButton) {
    event.preventDefault();

    const addonName = openButton.dataset.open;
    const addonEl = document.getElementById(`m-addons-${addonName}`);

    if (addonEl) {
      closeAllAddons();

      addonEl.classList.add("open");

      const contentHeight = addonEl.scrollHeight;
      addonEl.style.height = contentHeight + "px";

      overlay?.classList.add("open");
    }
    return;
  }

  const closeBtn = event.target.closest(
    ".m-cart-addon--close, .m-cart-addon--save"
  );

  if (closeBtn) {
    if (closeBtn.dataset.action === "coupon" || closeBtn.dataset.action === "note") return;
    event.preventDefault();
    closeAllAddons();
    return;
  }

  if (event.target.closest(".m-cart__overlay")) {
    event.preventDefault();
    closeAllAddons();
  }
});